import React from "react";
import Page from "./page";

const App = () => <Page />;

export default App;
